import { render, staticRenderFns } from "./ScannedGallery.vue?vue&type=template&id=39aedbcb&scoped=true&"
import script from "./ScannedGallery.vue?vue&type=script&lang=js&"
export * from "./ScannedGallery.vue?vue&type=script&lang=js&"
import style0 from "./ScannedGallery.vue?vue&type=style&index=0&id=39aedbcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aedbcb",
  null
  
)

export default component.exports